export default {
	Hi: "Salut",
	WelcomeBack: ", Bienvenue à dos",
	WalletBalance: {
		title: "Solde du portefeuille",
		tips: "Les profits seront ajoutés ici"
	},
	FrozenBalance: {
		title: "Solde gelé",
		tips: "Le montant gelé sera ajouté ici"
	},
	TodaysProfit: {
		title: "Profit d'aujourd'hui",
		tips: "Commission gagnée"
	},
	AwardFreezeBalance: {
		title: "Bonus Chance",
		tips: "Le bonus chanceux spécial sera ajouté ici"
	},
	awards: {
		LoginRewards: "Récompenses de connexion",
		WorkRewards: "Récompenses de travail"
	},
	withdrawalFeeRate: "Taux de frais de retrait",
	StartOptimization: "Démarrer l'optimisation",
	CompletedToday: "Terminé aujourd'hui",
	Start: "Démarrage",
	profit: "Profit",

	Notice: {
		title: "Avis",
		date: "Horaires d'assistance en ligne {0} - {1}",
		tips: "Veuillez contacter l'assistance en ligne pour obtenir de l'aide"
	},
	TaskDialog: {
		title: "Song Submission",
		TotalAmount: "Montant total",
		Profit: "Profit",
		TaskCode: "Code de la tâche",
		CreatedAt: "Créé le"
	},
	award: {
		title: ["FÉLICITATIONS POUR", "RECEVOIR LE TASKBONUS"],
		btn: "CLIQUER POUR RÉCLAMER "
	},
	firstAward: {
		title: ["Félicitations pour avoir reçu la récompense de financement :", "Les bonus augmenteront avec le temps"],
		btn: "Obtenir la récompense",
		getTips: "Récompense réclamée avec succès, la récompense sera créditée après avoir terminé un ensemble de tâches"
	},
	order: {
		title: [
			"Marque:",
			"Points Amazon :",
			"Frais d'expédition 0",
			"Arrivée prévue à partir de",
			"à",
			"Action",
			"pièces",
			"Notes",
			"Retour",
			"Ce produit prend en charge les retours et les échanges",
			"Paiement",
			"Transaction sécurisée",
			"Envoyé par le vendeur",
			"Engagement en faveur de la sûreté et de la sécurité",
			"Protection des informations client",
			"Informations de base",
			"Information produit",
			"Description",
			"Voir plus de détails",
			"Réduire les détails",
			"Images et vidéos",
			"Commentaires du Japon",
			"(Sur 5 points)",
			"Note globale",
			"Commentaires du Japon",
			"Parfait pour le vestiaire",
			"Évalué au Japon"
		],
		submitDialog: {
			additionalCommission: "Commission Supplémentaire",
			title: [
				"Cliquez pour écrire un commentaire :",
				"Écrire une critique",
				"Commentaire automatique",
				"Quantité commandée :",
				"Montant total",
				"Récompense",
				"Gains",
				"Date créée",
				"Code de commande",
				"Démarrer la commande",
				"Démarrer le compte à rebours"
			],
			rateList: [
				"The room was immaculate and cozy, perfect for a relaxing stay.",
				"The bed was incredibly comfortable, and the breakfast options were delicious and varied.",
				"The hotel went above and beyond my expectations.",
				"The hotel is eco-friendly, which I really appreciated.",
				"The hotel exceeded my expectations. The room was spacious and well-maintained, and the staff were friendly and attentive. The location was ideal for sightseeing and exploring the area.",
				"I had a pleasant stay at this hotel. The room was clean and well-furnished, with a comfortable bed. The staff were friendly and helpful, and the breakfast was fresh and varied.",
				"The hotel’s location was ideal for exploring the city. The room was comfortable and clean, and the staff were very friendly and accommodating. The breakfast was varied and tasty.",
				"The room had all the amenities I needed for a comfortable stay.",
				"We had a wonderful stay at this hotel. The room was clean, comfortable, and well-appointed. The breakfast was delicious, with plenty of options to choose from.",
				"The hotel offers excellent value for money. The room was clean, the bed was very comfortable, and the amenities were top-notch. Highly recommend for both business and leisure stays.",
				"The staff were quick to respond to any requests.",
				"The room was spotless and had a beautiful view. The staff were attentive and friendly, and the location was perfect for exploring the city. Highly recommend this hotel.",
				"The hotel's design was very chic and stylish.",
				"The room was clean, spacious, and had a very comfortable bed. The hotel’s location was ideal for exploring the city, and the staff were friendly and helpful throughout.",
				"The views from the room were stunning!",
				"The hotel’s design was very chic, and the staff were incredibly helpful. Loved the complimentary toiletries!",
				"A fantastic hotel with excellent amenities. The room was clean and spacious, and the staff were very helpful. The breakfast was a great start to the day, with plenty of choices.",
				"This hotel was a great choice. The room was clean, spacious, and had all the amenities I needed. The staff were polite and professional, making our stay very pleasant.",
				"Highly recommend for a relaxing getaway.",
				"The hotel was a great choice for our visit. The room was clean and spacious, with a very comfortable bed. The location was ideal, and the staff were friendly and helpful.",
				"Loved the art and decor throughout the hotel.",
				"Room service was quick and efficient.",
				"The room was clean, comfortable, and well-maintained. The hotel’s location was perfect, close to major attractions. The staff were also very friendly and provided excellent service.",
				"Great value for the money.",
				"I had a wonderful stay at this hotel. The room was spacious, clean, and well-maintained. The staff were friendly and accommodating, and the location was ideal for exploring the city.",
				"This hotel was a great choice for our vacation. The room was clean, spacious, and had a comfortable bed. The breakfast was varied and delicious, and the staff were very friendly.",
				"The hotel provided everything we needed for a relaxing stay. The room was clean, comfortable, and well-decorated. The staff were friendly and always ready to assist.",
				"The hotel had a great location, close to everything.",
				"The hotel was well-located, with clean and comfortable rooms. The staff were attentive and made sure we had everything we needed. The breakfast had a great variety of options.",
				"A fantastic stay at this hotel. The room was clean and well-furnished, and the staff were very helpful. The location was perfect for exploring the area, and the breakfast was varied and tasty.",
				"The room was spacious and clean, with a great view. The hotel's location was very convenient, and the breakfast was plentiful and delicious. Highly recommend for a city stay.",
				"The hotel exceeded our expectations in every way. The room was spacious, modern, and had a fantastic view. The staff were professional and made our stay very enjoyable.",
				"The room was very comfortable and had a great view.",
				"The location of the hotel is unbeatable, close to all major attractions. The room was comfortable, well-equipped, and the overall atmosphere of the hotel was very welcoming.",
				"The room was spotless and had a fantastic view. The staff were friendly and attentive, making sure we had everything we needed for a comfortable stay. Highly recommended.",
				"The hotel was super clean and well-maintained.",
				"A great hotel with excellent service. The room was clean, comfortable, and had everything I needed. The location was also very convenient for getting around the city.",
				"The hotel’s design was stylish, and the room was very clean.",
				"The breakfast buffet was huge and delicious.",
				"The gym and pool were great additions!",
				"The hotel was a great choice for our trip. The room was spacious, clean, and well-equipped. The staff were helpful, and the location was ideal for sightseeing and dining.",
				"Perfect location, with easy access to all the local hot spots.",
				"The hotel had a great breakfast selection.",
				"The hotel was very clean and well-kept.",
				"I had a wonderful stay and will definitely be back.",
				"Loved the complimentary toiletries.",
				"Loved the little extras like complimentary water and snacks.",
				"I was impressed with the quality of the room and the amenities provided. The hotel’s location made it easy to explore nearby attractions, and the breakfast options were excellent.",
				"The hotel grounds were beautifully landscaped.",
				"The room was comfortable and well-decorated, with all the amenities I needed for a great stay. The location was ideal, and the staff were friendly and attentive throughout.",
				"The hotel provided a wonderful experience. The room was clean, modern, and well-furnished. The staff were friendly and attentive, and the breakfast options were diverse and tasty.",
				"A fantastic hotel in a great location. The room was modern and comfortable, with a beautiful view. The staff were very accommodating, and the service was excellent.",
				"I loved the decor and ambiance of the hotel.",
				"The hotel had a cozy and comfortable feel.",
				"The staff were always smiling and willing to help.",
				"The room was well-lit, and the breakfast was well-organized.",
				"The hotel bar had a great atmosphere and a good selection.",
				"The location was perfect for sightseeing.",
				"The staff were incredibly friendly and helpful throughout our stay. The room was clean, modern, and very comfortable. The hotel’s location was perfect for our needs.",
				"The hotel was very quiet and peaceful.",
				"The staff went above and beyond to make sure I was comfortable.",
				"Late check-out was a great option.",
				"The hotel offered a very comfortable stay with its clean rooms and friendly staff. The location was convenient for exploring the city, and the breakfast had a great selection.",
				"The pool area was clean and very inviting.",
				"A wonderful hotel with great amenities. The room was spacious and well-maintained, and the staff were very friendly and helpful. The breakfast was varied and of high quality.",
				"A fantastic hotel in a great location. The room was clean and comfortable, with all the amenities we needed. The staff were friendly and helpful, making our stay enjoyable.",
				"The staff were always smiling and helpful.",
				"The room was spacious, clean, and had all the amenities I needed. The bed was incredibly comfortable, ensuring a great night’s sleep. Highly recommend this hotel for a relaxing stay.",
				"This hotel exceeded all expectations. The room was cozy and beautifully decorated, with every detail thoughtfully considered. The staff were attentive and very helpful.",
				"The staff went above and beyond to ensure our comfort. The room was spacious, with a great view, and the amenities were excellent. We thoroughly enjoyed our stay here.",
				"The room was modern and clean, with a comfortable bed. The hotel’s location was ideal for exploring local attractions, and the staff were friendly and helpful throughout our stay.",
				"The hotel provided a comfortable and enjoyable stay. The room was clean, modern, and well-equipped. The location was perfect for exploring the city, and the staff were very accommodating.",
				"Conveniently located near public transportation.",
				"The hotel provided a very relaxing environment.",
				"The hotel provided a very comfortable stay with its clean rooms and excellent service. The location was convenient for sightseeing, and the breakfast had a wide variety of options.",
				"The staff were always willing to help.",
				"I had a great experience at this hotel. The room was modern and clean, and the staff were friendly and attentive. The location was perfect for exploring the city, and the breakfast was fantastic.",
				"This hotel exceeded my expectations with its clean rooms and attentive staff. The bed was incredibly comfortable, and the complimentary breakfast had a wide variety of choices.",
				"This hotel was the perfect choice for our vacation. The room was clean, comfortable, and had all the amenities we needed. The staff were friendly and provided excellent service.",
				"The room was stylish and clean, with a very comfortable bed. The staff were friendly and accommodating, and the breakfast options were plentiful. The location was also very convenient.",
				"The bed was so comfortable, I didn’t want to get up!",
				"The hotel was clean, modern, and well-located. The room was spacious with a stunning view. The staff were professional and attentive, ensuring a pleasant stay.",
				"The hotel had a very welcoming and warm vibe.",
				"We had a wonderful time at this hotel. The room was spacious, well-maintained, and had a great view. The breakfast was delicious, with plenty of options to choose from.",
				"Perfect spot for a romantic weekend.",
				"This hotel was perfect for our needs. The room was clean, comfortable, and had all the amenities we required. The staff were friendly and accommodating, making our stay very pleasant.",
				"The hotel was in a great location, close to all the attractions. The room was clean and modern, and the staff were very helpful. The breakfast was varied and delicious.",
				"The hotel was spotless, with friendly and professional staff. The room was comfortable and well-appointed, and the breakfast was varied and tasty. A great choice for any traveler.",
				"The hotel was beautifully decorated and very clean. The room was comfortable, with all the necessary amenities. The staff were friendly and attentive, making our stay very enjoyable.",
				"We had a fantastic stay. The room was spacious, modern, and clean. The staff were very friendly and helpful, and the breakfast was plentiful and delicious. Highly recommend this hotel.",
				"A wonderful hotel with excellent service. The room was clean, spacious, and well-decorated. The breakfast was delicious, with plenty of choices. The location was also very convenient.",
				"The hotel provided a very comfortable stay. The room was modern, clean, and well-furnished. The staff were friendly and helpful, and the location was perfect for exploring the area.",
				"A fantastic hotel with great amenities. The room was spacious and clean, with a very comfortable bed. The staff were friendly and accommodating, making our stay very enjoyable.",
				"This hotel was a great choice. The room was clean, comfortable, and well-equipped. The staff were friendly and helpful, and the location was ideal for exploring the city.",
				"The hotel provided a very pleasant stay. The room was spacious, clean, and well-decorated. The staff were friendly and attentive, and the location was perfect for sightseeing.",
				"The staff were very accommodating and made sure our stay was comfortable. The room was spacious and clean, and the breakfast was delicious with plenty of variety.",
				"A great hotel with a fantastic location. The room was clean, modern, and very comfortable. The staff were helpful and attentive, and the breakfast was varied and tasty.",
				"The staff were friendly and made sure we had everything we needed. The room was clean, comfortable, and well-furnished, and the location was perfect for exploring the city.",
				"The room was clean and modern, with a comfortable bed and a great view. The hotel’s location was very convenient, and the staff were friendly and helpful. Highly recommended.",
				"The hotel had a great location, close to the city center. The room was comfortable, with a good selection of amenities. The staff were friendly and helpful, making our stay enjoyable.",
				"The hotel had everything we needed for a comfortable stay. The room was clean and modern, with a comfortable bed and a great view. The staff were friendly and attentive throughout.",
				"The hotel was well-located, with clean and comfortable rooms. The staff were attentive and made sure we had everything we needed. The breakfast had a great variety of options."
			],
			tips: ["Veuillez sélectionner un nombre d'étoiles", "Veuillez saisir un avis"]
		}
	}
};
